import { useEffect } from 'react';

import { useChatContext } from '../../../context/ChatContext';

import type { Channel, Event } from 'belo-js-sdk';

import type { DefaultBeloChatGenerics } from '../../../types/types';

export const useNotificationRemovedFromChannelListener = <
  BeloChatGenerics extends DefaultBeloChatGenerics = DefaultBeloChatGenerics
>(
  setChannels: React.Dispatch<React.SetStateAction<Array<Channel<BeloChatGenerics>>>>,
  customHandler?: (
    setChannels: React.Dispatch<React.SetStateAction<Array<Channel<BeloChatGenerics>>>>,
    event: Event<BeloChatGenerics>,
  ) => void,
) => {
  const { client } = useChatContext<BeloChatGenerics>('useNotificationRemovedFromChannelListener');

  useEffect(() => {
    const handleEvent = (event: Event<BeloChatGenerics>) => {
      if (customHandler && typeof customHandler === 'function') {
        customHandler(setChannels, event);
      } else {
        setChannels((channels) => channels.filter((channel) => channel.cid !== event.channel?.cid));
      }
    };

    client.on('notification.removed_from_channel', handleEvent);

    return () => {
      client.off('notification.removed_from_channel', handleEvent);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customHandler]);
};
